import { useState } from 'react';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import api from '../api';
import '../admin.css';

const NAV_SECTIONS = [
  {
    label: 'MAIN',
    items: [
      { icon: '⊞', label: 'Dashboard',   path: '/admin/dashboard',          permission: null },
    ],
  },
  {
    label: 'MANAGEMENT',
    items: [
      { icon: '👥', label: 'Users',       path: '/admin/dashboard/users',    permission: 'users' },
      { icon: '🖥',  label: 'Devices',    path: '/admin/dashboard/devices',  permission: 'devices' },
      // { icon: '🔑', label: 'License Keys',path: '/admin/dashboard/keys',     permission: 'licenseKeys' },
      { icon: '📦', label: 'App Versions',path: '/admin/dashboard/versions', permission: 'appVersions' },
    ],
  },
  {
    label: 'ADMIN',
    items: [
      { icon: '📋', label: 'Plans',       path: '/admin/dashboard/plans',      permission: 'superAdminOnly' },
      { icon: '💳', label: 'Payments',    path: '/admin/dashboard/payments',   permission: 'superAdminOnly' },
      { icon: '🛡', label: 'Roles',       path: '/admin/dashboard/roles',      permission: 'superAdminOnly' },
      { icon: '👤', label: 'Tech Users',  path: '/admin/dashboard/tech-users', permission: 'superAdminOnly' },
    ],
  },
];

export default function AdminDashboard() {
  const navigate = useNavigate();
  const location = useLocation();
  const admin = JSON.parse(localStorage.getItem('adminInfo') || '{}');
  const isSuperAdmin = admin.role === 'admin';

  const allNavItems = NAV_SECTIONS.flatMap(s => s.items);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const navSections = NAV_SECTIONS.map(section => ({
    ...section,
    items: section.items.filter(item => {
      if (item.permission === null) return true;
      if (item.permission === 'superAdminOnly') return isSuperAdmin;
      if (isSuperAdmin) return true;
      return (admin.permissions || []).includes(item.permission);
    }),
  })).filter(s => s.items.length > 0);

  const activeItem = allNavItems.find((item) =>
    item.path === '/admin/dashboard'
      ? location.pathname === '/admin/dashboard' || location.pathname === '/admin/dashboard/'
      : location.pathname.startsWith(item.path)
  ) || allNavItems[0];

  const handleLogout = async () => {
    try { await api.post('/admin/logout'); } finally {
      localStorage.removeItem('adminToken');
      localStorage.removeItem('adminInfo');
      navigate('/admin/login');
    }
  };

  return (
    <div className="admin-root">
      {sidebarOpen && (
        <div className="admin-overlay" onClick={() => setSidebarOpen(false)} />
      )}

      {/* Sidebar */}
      <aside className={`admin-sidebar${sidebarOpen ? ' open' : ''}`}>
        <div className="brand">
          <img src="/app-logo.svg" alt="Logo" style={{ width: 36, height: 36, borderRadius: 10, objectFit: 'contain' }} />
          <span className="brand-text">Shield Secure</span>
        </div>
        <nav className="admin-nav">
          {navSections.map(section => (
            <div key={section.label}>
              <div className="nav-section-label">{section.label}</div>
              {section.items.map(({ icon, label, path }) => (
                <div
                  key={label}
                  className={`nav-item${activeItem.label === label ? ' active' : ''}`}
                  onClick={() => { navigate(path); setSidebarOpen(false); }}
                >
                  <span style={{ fontSize: 16, width: 20, textAlign: 'center', flexShrink: 0 }}>{icon}</span>
                  <span>{label}</span>
                </div>
              ))}
            </div>
          ))}
        </nav>
        <div className="sidebar-footer">
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <div className="avatar" style={{ width: 32, height: 32, fontSize: 13 }}>{(admin.name || 'A')[0].toUpperCase()}</div>
            <div>
              <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-primary)' }}>{admin.name || 'Admin'}</div>
              <div style={{ fontSize: 11, color: 'var(--text-muted)' }}>{admin.role === 'admin' ? 'Super Admin' : 'Sub Admin'}</div>
            </div>
          </div>
        </div>
      </aside>

      {/* Main */}
      <div className="admin-main">
        {/* Topbar */}
        <header className="topbar">
          <div className="topbar-left">
            <button className="menu-btn" onClick={() => setSidebarOpen(!sidebarOpen)}>☰</button>
            <span className="page-title">{activeItem.label}</span>
          </div>
          <div className="topbar-right">
            {/* <div className="notif-bell">
              <span>🔔</span>
              <span className="notif-dot">3</span>
            </div> */}
            <div className="admin-info-wrap">
              <div className="avatar">{(admin.name || 'A')[0].toUpperCase()}</div>
              <span className="admin-name-text">{admin.name || admin.email}</span>
            </div>
            <button className="logout-btn" onClick={handleLogout}>Logout</button>
          </div>
        </header>

        {/* Content */}
        <div className="content">
          <div className="breadcrumb">
            <span className="bread-home" onClick={() => navigate('/admin/dashboard')}>Home</span>
            <span className="bread-sep">›</span>
            <span style={{ color: 'var(--text-secondary)' }}>{activeItem.label}</span>
          </div>
          <Outlet />
        </div>
      </div>
    </div>
  );
}
